import { gql } from "@apollo/client";

// Requires write access to the node plus administrateContactPersons (otto_crm);
// the contact must belong to the node's own client. Assigning twice returns the
// existing assignment instead of failing.
export const AssignContactPersonToInstalledBaseNode = gql`
    mutation AssignContactPersonToInstalledBaseNode($contactPersonId: ID!, $installedBaseNodeId: ID!) {
        assignContactPersonToInstalledBaseNode(contactPersonId: $contactPersonId, installedBaseNodeId: $installedBaseNodeId) {
            id
            inheritedFrom {
                id
            }
            contactPerson {
                id
            }
        }
    }
`;
